import React from 'react';
import { Config } from '@deporvillage/utils-library-component';

const ReviewsTrustpilot = () => {

    const elem = React.useRef(null);
    const { trustpilot } = React.useContext(Config);

    const isElementInViewport = (elem) => {
        const { top } = elem.getBoundingClientRect();
        /* eslint-disable-next-line no-undef */
        return top && top < window.innerHeight + 100;
    };

    const handleLoadWidget = () => {
        if (elem && elem.current && isElementInViewport(elem.current)) {
            /* eslint-disable no-undef */
            let script = document.createElement("script");
            script.src = trustpilot.scriptSrc;
            script.async = true;
            script.setAttribute('fetchpriority', 'low');
            elem.current.appendChild(script);
            window.removeEventListener('scroll', handleLoadWidget);
            /* eslint-enable no-undef */
        }
    };

    React.useEffect(() => {
        handleLoadWidget();
        /* eslint-disable no-undef */
        window.addEventListener('scroll', handleLoadWidget);
        return () => { window.removeEventListener('scroll', handleLoadWidget); };
        /* eslint-enable no-undef */
    }, []);

    return !trustpilot ? null : <div className="reviews-trustpilot-component trustpilot-widget" ref={ elem }
                data-locale={ trustpilot.local }
                data-template-id="54ad5defc6454f065c28af8b"
                data-businessunit-id={ trustpilot.id }
                data-style-height="250px"
                data-style-width="100%"
                data-theme="light"
                data-stars="3,4,5"
                data-schema-type="Organization">
        <a href={ trustpilot.url } target="_blank" rel="noopener noreferrer">Trustpilot</a>
    </div>;
};

export default ReviewsTrustpilot;
